import {
    Input,
    Component,
    Output,
    EventEmitter,
    OnDestroy
} from '@angular/core';
import { IDynamicallyCreatedComponent } from '../core-data-model/DynamicallyCreated.component';
import { TranslationService } from '../translations';

@Component({
    template: `
        <div class="pi-modalBody_leftAlignText">
            <i class="fa fa-warning"></i>
            <div [innerHTML]="text"></div>
        </div>
        <div class="pi-modalFooter">
            <button
                type="button"
                class="btn btn--lsg btn--lsg--primary"
                (click)="confirmRequest(true)"
            >
                {{ TR.key(confirmationButtonKeys.yes) }}
            </button>
        </div>
    `,
    standalone: false
})
export class SingleChoiceConfirmationComponent
    implements IDynamicallyCreatedComponent, OnDestroy
{
    @Output()
    readonly confirm = new EventEmitter();

    outputEvents = ['confirm'];
    subscriptions: any[];

    @Input()
    text = '';
    @Input()
    confirmationButtonKeys: {
        yes: string;
        no: string;
    };

    get propertiesList(): string[] {
        return ['text', 'confirmationButtonKeys'];
    }

    constructor(public TR: TranslationService) {}

    confirmRequest(isConfirmed: boolean) {
        this.confirm.emit(isConfirmed);
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => {
                subscription.unsubscribe();
            });
        }
    }
}
